import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { CrudService } from 'src/app/services/crud.service';
import { LocalDataService } from 'src/app/services/local-data.service';
import CustomStore from 'devextreme/data/custom_store';
import { environment } from 'src/environments/environment';
import notify from 'devextreme/ui/notify';
import { ConfirmationService } from 'src/app/services/confirmation.service';
import { HorizontalMenuService } from 'src/app/services/horizontalmenu.service';
import { DxDataGridComponent, DxDataGridModule, DxLoadPanelModule } from 'devextreme-angular';
import { JoyrideModule } from 'ngx-joyride';
import { JourneyService } from 'src/app/services/journey.service';
import { PageHeaderComponent } from 'src/app/shared/page-header/page-header.component';
@Component({
    selector: 'app-store-positions',
    templateUrl: './store-positions.component.html',
    styleUrls: ['./store-positions.component.css'],
    imports: [ DxDataGridModule, DxLoadPanelModule, JoyrideModule, PageHeaderComponent ],
    standalone: true
})
export class StorePositionsComponent implements AfterViewInit {
  public dataSource: CustomStore;
  public loading: boolean = true;
  private apiUrl: string = environment.baseApiUrl;
  editStorePositions: boolean;
@ViewChild("storePositionGrid", { static: false }) public dataGrid: DxDataGridComponent;

  constructor(private crudService: CrudService,
    private localData: LocalDataService,
    private confirmationService:ConfirmationService,
    private horizontalMenuService:HorizontalMenuService,
    private journeyService: JourneyService) {
    this.dataSource = new CustomStore<any>({
      key: 'id',
      load: async () => {
        this.loading = true;
        return await new Promise((resolve) => {
          this.crudService.getData(`${this.apiUrl}store-positions`).subscribe((result: apiResponse) => {
            if(result.success) {
              localStorage.setItem('store-positions', JSON.stringify(result.data));
              resolve({data: result.data, totalCount: result.totalCount});
            } else {
              notify({message: result.data[0].message}, 'error');
            }
            this.loading = false;
          })
        })
      },
      insert: async (values: StorePositions) => {
        this.loading = true;
        return await new Promise(async (resolve) => {
          values = this.setLocationDetails(values);
          await this.crudService.insertData(`${this.apiUrl}store-positions`, values)
          .subscribe((result: any) => {
            if(result.success) {
              notify({message: result.data}, 'success');
              this.localData.addData('store-positions', values);
              resolve(result);
            } else {
              notify({message: result.data}, 'error');
            }
            this.loading = false;
          });
        });
      },
      update: async (key: number, values: StorePositions) => {
        this.loading = true;
        return await new Promise(async (resolve) => {
          values = this.setLocationDetails(values);
          await this.crudService.updateData(`${this.apiUrl}store-positions`, key, values)
          .subscribe((result: any) => {
            if(result.success) {
              notify({message: result.data}, 'success');
              this.localData.updateData('store-positions', key, values);
              resolve(result);
            } else {
              notify({message: result.data}, 'error');
            }
            this.loading = false;
          });
        });
      },
      remove: async (key: number) => {
        this.loading = true;
        return await new Promise(async (resolve) => {
          await this.crudService.deleteData(`${this.apiUrl}store-positions`, key)
          .subscribe((result: any) => {
            if(result.success) {
              notify({message: result.data}, 'success');
              this.localData.removeData('store-positions', key);
              resolve(result);
            } else {
              notify({message: result.data}, 'error');
            }
            this.loading = false;
          });
        });
      }
    })
    this.horizontalMenuService.editStorePositions$.subscribe((value: boolean) => {
      this.editStorePositions = value;
    });
  }

  setLocationDetails(values: StorePositions): StorePositions
  {
    const userDetails = localStorage.getItem('userDetails');
    const parsedDetails = JSON.parse(userDetails || '{}');
    values.group_id = parsedDetails.data.group_id;
    values.location_id = parsedDetails.data.location_id;
    return values;
  }
  ngAfterViewInit(): void {
    this.journeyService.tryStartPhase('settings-store-positions');
  }

  onHiding(event:any){
    this.confirmationService.checkUnsaved(event, this.dataGrid, (value:boolean) => this.horizontalMenuService.seteditStorePositions(value))
  }
}

export class apiResponse
{
  data: Array<any>;
  totalCount: number;
  success: boolean;
}

export class StorePositions
{
  id: number;
  group_id: number;
  location_id: number;
  position_name: string;
  position_description: string;
  created_at: string;
  updated_at: string;
}
